/**
 * Created by fers on 03.08.16.
 */

import React from 'react';
import PropTypes from 'prop-types';
import ChannelIcon from '../../channel-defs/ChannelIcon.react';
import PureRenderMixin from 'react-addons-pure-render-mixin';

export default class BoxDecorator extends React.Component {
    static propTypes = {
        children: PropTypes.any,
		className: PropTypes.string,
        icon: PropTypes.string.isRequired,
        isPreview: PropTypes.bool,
		padding: PropTypes.bool,
		title: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        return (
            <div className={"dativeryPlatformBox " + this.props.className }>
                <div className="dativeryPlatformTitle">
                    <div title={this.props.title || null}>
						{this.props.icon ? <ChannelIcon channelDef={this.props} size={32}/> : null}
					</div>
                </div>
                <div className={"dativeryPlatformContent " + (this.props.isPreview ? 'dativeryPlatformContentPreview' : '')} style={{padding: this.props.padding ? '5px' : undefined}}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}
